<template>
  <div class="sort-list">
    <sort-item
      :disabled="disabled"
      v-for="(item, index) in sorts"
      :key="index"
      :sheet="item"
      :sheet-list="localControls"
      :select-sheets="selectSheets"
      @add="add(index)"
      @remove="remove(index)"
      class="item-wrapper"
      :from="from"
    ></sort-item>
  </div>
</template>
<script>
import SortItem from "./SortItem"
import { transFieldControl } from "@/utils/sheet"
export default {
  components: { SortItem },
  name: "sort-list",
  data() {
    return {
      sortList: []
    }
  },
  props: {
    sheetList: Array,
    sorts: Array,
    disabled: Boolean,
    from: String
  },
  watch: {
    sorts() {
      if (this.sorts.length == 0)
        this.sorts.push({
          key: "id",
          direction: "DESC"
        })
    }
  },
  created() {
    this.refresh()
  },
  computed: {
    selectSheets() {
      return this.sorts.map(x => {
        return x.key
      })
    },
    localControls() {
      return (this.sheetList || [])
        .concat(
          this.from === "refControl"
            ? []
            : [
                { name: "创建人", _cid: "cid", _type: "staff" },
                { name: "负责人", _cid: "oid", _type: "staff" },
                { name: "最后修改人", _cid: "upid", _type: "staff" },
                { name: "创建时间", _cid: "id", _type: "ref" },
                { name: "最后修改时间", _cid: "uat", _type: "time" }
              ]
        )
        .map(control => transFieldControl(control))
    }
  },
  methods: {
    refresh() {
      if (this.sorts && this.sorts.length == 0)
        this.sorts.push({
          key: "id",
          direction: "DESC"
        })
    },
    add(index) {
      this.sorts.splice(index + 1, 0, {
        key: this.sheetList.find(sheet => !this.selectSheets.includes(sheet._cid))._cid,
        direction: "ASC"
      })
    },
    remove(index) {
      this.sorts.splice(index, 1)
    }
  }
}
</script>
<style lang="scss" scoped>
.sort-list {
  .add-button {
    padding: 0 12px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    background: #f5f5f5;
    cursor: pointer;
    color: #1e88e5;
  }
  .item-wrapper {
    &:not(:last-child) {
      margin-bottom: 6px;
    }
  }
}
</style>
